
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetotuljapurcabs() {



    const cardData =
    {
        keyword: 'Pune to Tuljapur Cab',
        heading: 'Platinum24 Cabs: Pune to Tuljapur Cab',
        headingDescription: ' Platinum24 Cabs provides convenient Pune to Tuljapur Cab services, ideal for devotees traveling to the famous Tulja Bhavani Temple. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable journey on the Pune–Tuljapur route, with ample space for families and groups. With professional chauffeurs, punctual service, and flexible one-way or round-trip options, we make your pilgrimage stress-free and reliable. Whether you’re planning a same-day darshan or a multi-day religious tour, Platinum24 Cabs guarantees affordable fares, clean vehicles, and a spiritually fulfilling travel experience from Pune to Tuljapur.',

        top: 'Top Places to Visit in Tuljapur with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Tulja Bhavani Temple",
    "description": "The Tulja Bhavani Temple is the spiritual heart of Tuljapur, dedicated to Goddess Bhavani – one of the Sade Teen Shakti Peethas of Maharashtra. Built in the 12th century, the temple is closely associated with Chhatrapati Shivaji Maharaj, who sought blessings here and received the divine ‘Bhavani Talwar.’ The sanctum houses a powerful granite idol of Goddess Bhavani. Navratri Yatra attracts lakhs of devotees from across India. The temple is Tuljapur’s divine center of strength, faith, and protection."
  },
  {
    "title": "Kalbhairav Temple",
    "description": "Situated within the Tulja Bhavani temple complex, the Kalbhairav Temple is dedicated to Lord Kalbhairav, the guardian deity of Tuljapur. Devotees believe darshan here is essential after worshipping Goddess Bhavani. The shrine radiates spiritual energy and protection. Rituals and offerings are performed daily, especially during Navratri. Pilgrims feel a sense of completeness after visiting both shrines. Kalbhairav Temple is Tuljapur’s guardian seat of devotion."
  },
  {
    "title": "Annapurna Math",
    "description": "Annapurna Math near the Tulja Bhavani Temple is dedicated to Goddess Annapurna, the giver of food and nourishment. Devotees believe that offering prayers here ensures prosperity and abundance. The math also serves free meals to pilgrims, reflecting the tradition of seva (service). Its peaceful setting makes it ideal for prayer and meditation. Annapurna Math is Tuljapur’s sacred place of compassion and nourishment."
  },
  {
    "title": "Ghatshila Temple",
    "description": "Ghatshila Temple is a serene shrine dedicated to Lord Shiva, located a few kilometers from Tuljapur. Surrounded by rocky hills and forests, it is a popular picnic spot and spiritual retreat. During monsoon, the area is filled with streams and greenery. Local legends connect the temple with Goddess Bhavani’s blessings. It is less crowded, offering peace and nature’s charm. Ghatshila Temple is Tuljapur’s hidden gem of divinity and beauty."
  },
  {
    "title": "Homgiri Ashram",
    "description": "Homgiri Ashram, located near Tuljapur, is a spiritual retreat inspired by saints and sages of Maharashtra. The ashram conducts meditation, satsangs, and community service. Devotees visit for inner peace and guidance. Its calm atmosphere amidst nature attracts spiritual seekers. The ashram also organizes charitable initiatives. Homgiri Ashram is Tuljapur’s abode of meditation and devotion."
  },
  {
    "title": "Paapnashi Tirth",
    "description": "Paapnashi Tirth is a holy water tank located near Tulja Bhavani Temple. Pilgrims take a ritual bath here before entering the temple, believing it washes away sins. The tirth has mythological significance and is considered sacred in Shakti worship. During Navratri and yatra festivals, thousands gather here. Surrounded by ancient steps and stone structures, it has a heritage feel. Paapnashi Tirth is Tuljapur’s sacred purification spot."
  },
  {
    "title": "Chincholi Forest",
    "description": "The Chincholi Forest area near Tuljapur is known for its greenery and natural charm. It provides a refreshing break for pilgrims after temple visits. Birdwatchers and nature lovers enjoy exploring its flora and fauna. Small shrines and hidden spots are scattered across the forest. Monsoon enhances its scenic beauty with streams and waterfalls. Chincholi Forest is Tuljapur’s natural retreat for peace seekers."
  },
  {
    "title": "Siddheshwar Temple, Solapur",
    "description": "Located about 45 km from Tuljapur, Siddheshwar Temple in Solapur is dedicated to Lord Siddheshwar, considered a form of Lord Shiva. Built in Hemadpanthi style, the temple is situated in the middle of a lake. Thousands visit during the annual fair in January. Pilgrims from Tuljapur often extend their journey here. It blends devotion, architecture, and cultural traditions. Siddheshwar Temple is Tuljapur’s nearby spiritual extension."
  },
  {
    "title": "Osmanabad Fort",
    "description": "Osmanabad Fort, located near Tuljapur, reflects the Deccan’s historical legacy. Built in medieval times, the fort has bastions, gates, and panoramic views. It narrates stories of Yadava, Bahamani, and Maratha rule. History lovers explore its ancient structures and surroundings. It is a short excursion for those visiting Tuljapur. Osmanabad Fort is Tuljapur’s heritage symbol of strength and valor."
  },
  {
    "title": "Dharashiv Caves",
    "description": "Dharashiv Caves near Osmanabad, close to Tuljapur, are ancient rock-cut caves dating back to the 6th century. Initially Buddhist, they were later converted into Hindu shrines. The caves feature intricate carvings, pillars, and meditation chambers. They reflect the spiritual and artistic excellence of ancient India. Pilgrims and tourists visit to explore history and heritage. Dharashiv Caves are Tuljapur’s ancient treasure of art and devotion."
  }
],



      "services": [
    {
      "name": "Pune to Tuljapur Cab Service",
      "description": "Reliable and comfortable cab service from Pune to Tuljapur, ideal for pilgrims, tourists, and travelers seeking a hassle-free journey to the sacred town of Tuljapur, home to the famous Tulja Bhavani Temple. Our service ensures punctual pickups, well-maintained vehicles, and experienced drivers who prioritize your safety and convenience throughout the trip."
    },
    {
      "name": "Tuljapur Taxi from Pune",
      "description": "Affordable and efficient taxi options from Pune to Tuljapur, including sedans, SUVs, and tempo travellers suitable for individual travelers and groups. Enjoy flexible booking, clean vehicles, and friendly drivers who are familiar with local routes and pilgrimage schedules."
    },
    {
      "name": "Pune Tuljapur Taxi Booking",
      "description": "Book your taxi from Pune to Tuljapur effortlessly through our online platform or customer support. Get instant confirmation, transparent pricing, and a variety of vehicle choices tailored to your travel needs, whether for personal visits, family trips, or religious tours."
    },
    {
      "name": "Tuljapur Pilgrimage Taxi Pune",
      "description": "Specialized taxi services catering to pilgrims traveling from Pune to Tuljapur. Our vehicles are well-suited for long journeys and provide a comfortable ride for devotees visiting the Tulja Bhavani Temple. Drivers are experienced in handling pilgrimage routes, ensuring timely arrival and smooth travel."
    },
    {
      "name": "Pune to Tuljapur Car Rental",
      "description": "Flexible car rental options from Pune to Tuljapur, including self-drive and chauffeur-driven vehicles. Ideal for travelers who prefer personalized schedules and the freedom to explore Tuljapur and nearby attractions at their own pace."
    },
    {
      "name": "Tuljapur Taxi Packages Pune",
      "description": "Comprehensive taxi packages for Pune to Tuljapur trips covering fuel, tolls, driver allowances, and optional sightseeing. Choose from hourly, daily, or custom packages that fit your pilgrimage or travel plans perfectly, with no hidden charges."
    },
    {
      "name": "Affordable Cab Pune to Tuljapur",
      "description": "Budget-friendly cab services from Pune to Tuljapur that offer quality and comfort without straining your wallet. Perfect for travelers seeking economical yet reliable transportation for religious visits or leisure trips."
    },
    {
      "name": "Pune Tuljapur Private Taxi",
      "description": "Exclusive private taxi service from Pune to Tuljapur ensuring privacy and convenience for families, groups, and corporate travelers. Enjoy personalized routes, flexible timings, and dedicated drivers committed to your comfort."
    },
    {
      "name": "Pune to Tuljapur Taxi Fare",
      "description": "Transparent and competitive taxi fare details for trips between Pune and Tuljapur. Get accurate fare estimates based on your vehicle choice, trip duration, and travel dates, helping you plan your budget effectively."
    },
    {
      "name": "Tuljapur Cab Charges Pune",
      "description": "Detailed information on cab charges for Pune to Tuljapur routes, including all applicable costs such as fuel, tolls, and driver allowances. This enables travelers to make informed decisions and select the best service for their needs."
    },
    {
      "name": "Pune to Tuljapur Taxi Hire",
      "description": "Flexible taxi hire options from Pune to Tuljapur, available for short or long durations. Whether you need a quick one-way trip or a full-day tour, our taxi hire services provide reliable vehicles and professional drivers."
    },
    {
      "name": "Tuljapur Temple Taxi Service Pune",
      "description": "Dedicated taxi service for pilgrims visiting the Tulja Bhavani Temple in Tuljapur. Our taxis ensure timely pickups and drop-offs, comfortable rides, and experienced drivers who understand the significance of your spiritual journey."
    },
    {
      "name": "Pune to Tuljapur One Way Cab",
      "description": "Cost-effective one-way cab services from Pune to Tuljapur, ideal for travelers who require point-to-point transportation without the need for a return trip. Enjoy hassle-free travel with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Pune Tuljapur Taxi with Driver",
      "description": "Experienced and courteous drivers provided with every taxi booking from Pune to Tuljapur to ensure a safe and pleasant journey. Drivers are knowledgeable about the best routes, traffic conditions, and local customs."
    },
    {
      "name": "Taxi Service Pune to Tuljapur",
      "description": "Comprehensive taxi service options from Pune to Tuljapur available 24/7. Whether for local transfers, pilgrimage tours, or leisure travel, our taxi services guarantee timely pickups, clean vehicles, and excellent customer support."
    }
  ],
  "tableData": [
    ["Pune to Tuljapur Cab Service", "Tuljapur Taxi from Pune"],
    ["Pune Tuljapur Taxi Booking", "Tuljapur Pilgrimage Taxi Pune"],
    ["Pune to Tuljapur Car Rental", "Tuljapur Taxi Packages Pune"],
    ["Affordable Cab Pune to Tuljapur", "Pune Tuljapur Private Taxi"],
    ["Pune to Tuljapur Taxi Fare", "Tuljapur Cab Charges Pune"],
    ["Pune to Tuljapur Taxi Hire", "Tuljapur Temple Taxi Service Pune"],
    ["Pune to Tuljapur One Way Cab", "Pune Tuljapur Taxi with Driver"],
    ["Taxi Service Pune to Tuljapur", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Trusted Pune to Tuljapur Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable cab rides from Pune to Tuljapur for a hassle-free journey."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Route Knowledge",
      "WhyChoosedescription": "Our skilled drivers are familiar with the Pune to Tuljapur route to ensure a safe and timely trip."
    },
    {
      "WhyChooseheading": "Clean, Well-Maintained Vehicles for Long-Distance Travel",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs designed for comfort on your journey."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way or Round Trips",
      "WhyChoosedescription": "Choose travel packages tailored to your schedule and preferences."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
      "WhyChoosedescription": "Enjoy all-inclusive fares covering fuel, tolls, and driver allowances for stress-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Bookings",
      "WhyChoosedescription": "Our dedicated team is available round the clock to assist with your booking and travel needs."
    },
    {
      "WhyChooseheading": "Comfortable Ride Suitable for Families and Groups",
      "WhyChoosedescription": "Our cabs accommodate various group sizes and luggage needs for a pleasant journey."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options Available",
      "WhyChoosedescription": "Select from hatchbacks, sedans, or SUVs based on your comfort and group requirements."
    }
  ]
































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Tuljapur?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel between Pune and Tuljapur.',
    },
    {
        question: 'How can I book a Pune to Tuljapur cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Tuljapur cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Tuljapur trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Tuljapur?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Tuljapur route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Tuljapur?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Tuljapur cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Tuljapur rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Tuljapur route.',
    },
    {
        question: 'Are safety measures in place for Pune to Tuljapur cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Tuljapur travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Tuljapur?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Tuljapur routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sandeep Shinde',
        feedback: 'The Pune to Tuljapur cab service by Platinum24 Cabs was punctual and the driver was very professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Ritu Patil',
        feedback: 'Booking a cab to Tuljapur was easy and the trip was comfortable and hassle-free with Platinum24 Cabs.',
        rating: 5,
    },
];










































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneToTuljapurCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Tuljapur Cab",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-tuljapur-cab.jpg",
  "description": "Book Pune to Tuljapur cab with Platinum24 Cabs. AC taxis and private car rentals available for Tulja Bhavani temple pilgrimage. One-way, round trip, and customized cab packages with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-tuljapur-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Tuljapur Cab | Tulja Bhavani Temple Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Tuljapur cab with Platinum24 Cabs. Private AC taxis, round trip & one-way options available for Tulja Bhavani temple pilgrimage. Safe & affordable travel with professional drivers."
  />
  <meta
    name="keywords"
    content="Pune to Tuljapur Cab Service, Tuljapur Taxi from Pune, Pune Tuljapur Taxi Booking, Tuljapur Pilgrimage Taxi Pune, Pune to Tuljapur Car Rental, Tuljapur Taxi Packages Pune, Affordable Cab Pune to Tuljapur, Pune Tuljapur Private Taxi, Pune to Tuljapur Taxi Fare, Tuljapur Cab Charges Pune, Pune to Tuljapur Taxi Hire, Tuljapur Temple Taxi Service Pune, Pune to Tuljapur One Way Cab, Pune Tuljapur Taxi with Driver, Taxi Service Pune to Tuljapur"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToTuljapurCabsSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/36.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetotuljapurcabs;